export default "__VITE_ASSET__C9pKv12P__"